import { render } from "./Budget.vue?vue&type=template&id=ed3997a4&scoped=true"
import script from "./Budget.vue?vue&type=script&lang=js"
export * from "./Budget.vue?vue&type=script&lang=js"

import "./Budget.vue?vue&type=style&index=0&id=ed3997a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed3997a4"]])

export default __exports__